export default __webpack_public_path__ + "static/media/Snd_23.a0f7b9a7.mp3";